import type { TFunction } from 'i18next';
import type { Recipe } from '@/types';

export const recipeCategoryOptions = ['gelato', 'otro'] as const;
export const recipeSubcategoryOptions = [
  'crema_blanca',
  'crema_manchada',
  'sorbete_fruta',
  'chocolate_fruto_seco',
] as const;

export type RecipeCategoryOption = (typeof recipeCategoryOptions)[number];
export type RecipeSubcategoryOption = (typeof recipeSubcategoryOptions)[number];

export function getRecipeCategoryLabel(t: TFunction, value: RecipeCategoryOption) {
  return t(`recipes.categoryOptions.${value}`);
}

export function getRecipeSubcategoryLabel(t: TFunction, value: RecipeSubcategoryOption) {
  return t(`recipes.subcategoryOptions.${value}`);
}

export function getRecipeClassification(recipe: Pick<Recipe, 'recipe_category' | 'recipe_subcategory' | 'recipe_type_name'>, t: TFunction) {
  const parts: string[] = [];

  if (recipe.recipe_category) {
    parts.push(getRecipeCategoryLabel(t, recipe.recipe_category));
  }

  if (recipe.recipe_subcategory) {
    parts.push(getRecipeSubcategoryLabel(t, recipe.recipe_subcategory));
  }

  if (recipe.recipe_type_name) {
    parts.push(recipe.recipe_type_name);
  }

  return parts;
}